import { Button } from "components/Button";
import { Form, FormColumn, FormRow } from "components/Forms/Form";
import { Select } from "components/Forms/Select";
import { TextField } from "components/Forms/TextField";

import { Plan } from "models/plan";

import { StatusSelect } from "components/Forms/StatusSelect";
import { FormFields, useViewModel } from "./viewModel";

type PlanFormProps = {
  plan?: Plan;
  onSubmit?: (fields: FormFields) => Promise<void>;
  enabled: boolean;
  action?: string;
};

export function PlanForm({
  plan,
  enabled,
  action,
  onSubmit,
}: PlanFormProps) {
  const {
    handleSubmit,
    errors,
    register,
    setValue,
    loading,
    status,
    handleChangeProvider,
    providers,
    selectedProviderId,
    user,
    t,
  } = useViewModel(plan, onSubmit);

  return (
    <Form onSubmit={handleSubmit} className="mt-12 tablet:mt-24">
      <FormRow>
        <FormColumn>
          <TextField
            label={t("plans.form.name")}
            placeholder={t("plans.form.name_placeholder")}
            error={errors.name?.message}
            disabled={!enabled}
            register={register("name", {
              required: {
                value: true,
                message: t("plans.form.name_required"),
              },
              minLength: {
                value: 3,
                message: t("plans.form.name_min_length"),
              },
            })}
          />
          <TextField
            label={t("plans.form.description")}
            placeholder={t("plans.form.description_placeholder")}
            error={errors.description?.message}
            disabled={!enabled}
            register={register("description", {
              required: {
                value: true,
                message: t("plans.form.description_required"),
              },
              minLength: {
                value: 10,
                message: t("plans.form.description_min_length"),
              },
            })}
          />
          <TextField
            label={t("plans.form.price")}
            type="number"
            step="0.01"
            placeholder={t("plans.form.price_placeholder")}
            error={errors.price?.message}
            disabled={!enabled}
            register={register("price", {
              required: {
                value: true,
                message: t("plans.form.price_required"),
              },
              min: {
                value: 0,
                message: t("plans.form.price_min"),
              },
              valueAsNumber: true,
            })}
          />
          {user?.role === "admin" ? (
            <Select
              onChange={handleChangeProvider}
              options={
                providers?.map((provider) => ({
                  label: provider.name,
                  value: provider.id,
                })) ?? []
              }
              selected={selectedProviderId}
              disabled={!enabled}
              placeholder={t("plans.form.provider_placeholder")}
              label={t("plans.form.provider")}
              error={errors.providerId?.message}
            />
          ) : null}
          <StatusSelect
            label={t("plans.form.status")}
            selected={status}
            disabled={!enabled}
            options={[
              { label: t("plans.status.active"), value: "active" },
              { label: t("plans.status.inactive"), value: "inactive" },
            ]}
            onChange={(value) => setValue("status", value as "active" | "inactive")}
          />
        </FormColumn>
      </FormRow>
      {action && (
        <Button
          type="submit"
          size="default"
          loading={loading}
          className="w-48 mt-20"
        >
          {action}
        </Button>
      )}
    </Form>
  );
} 